"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _reactReduxI18n = require("react-redux-i18n");

var _arrays = require("../../utils/arrays");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Stepper(props) {
  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  function handleNext(data) {
    var nextStep = activeStep + 1;

    if (nextStep >= props.steps.length) {
      props.onFinish();
    } else {
      props.onNextStep(nextStep, data);
      setActiveStep(nextStep);
    }
  }

  function handleSkip() {
    if (!props.steps[activeStep].optionnal) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    handleNext();
  }

  var renderStepLabel = function renderStepLabel(step, index) {
    var label = index === activeStep ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: step.label
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: step.label
      })
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Step, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.StepLabel, {
        children: label
      })
    }, step.label);
  };

  function renderStep() {
    var steps = props.steps,
        stepProps = props.stepProps;
    return steps[activeStep].render(_objectSpread({
      goToNextStep: handleNext,
      skipStep: handleSkip,
      isProjectCreationFunnel: true
    }, stepProps));
  }

  if (!props.steps || (0, _arrays.isEmpty)(props.steps) || activeStep >= props.steps.length) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Stepper, {
      alternativeLabel: true,
      activeStep: activeStep,
      children: props.steps.map(renderStepLabel)
    }), renderStep()]
  });
}

Stepper.defaultProps = {
  onNextStep: function onNextStep() {},
  stepProps: {}
};
Stepper.propTypes = {
  steps: _propTypes.default.array.isRequired,
  onNextStep: _propTypes.default.func,
  onFinish: _propTypes.default.func.isRequired,
  stepProps: _propTypes.default.object
};
var _default = Stepper;
exports.default = _default;
//# sourceMappingURL=Stepper.js.map